import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { RequestsStates } from "../../data/enums/requestsStates";
import { TemplateData } from "../../data/templateData";
import { ActionStateEnum } from "../../models/enums/operStateEnum";
import { OperationModel } from "../../models/operations/operationModel";
import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { TemplatesApi } from "../api/TemplatesApi";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import ITemplatesService from "./ITemplatesService";

/**Сервис проведения операций */
@injectable()
export default class TemplatesService implements ITemplatesService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {}

  public async fetchTemplates(): Promise<Array<TemplateData>> {
    let res: Array<TemplateData> = [];
    try {
      res = await TemplatesApi.getTemplatesAsync();
    } catch (e) {
      this.errorService.errorHandler(e, false, true, "");
    }
    return res;
  }

  public async deleteTemplate(templateId: number): Promise<void> {
    try {
      await TemplatesApi.deleteTemplateAsync(templateId);
    } catch (e) {
      this.errorService.errorHandler(e, false, true, "");
    }
  }
}
